/** @format */
import React, { useState, useEffect, useMemo, useContext } from 'react'
import styled from 'styled-components'
import { CountContext } from 'src/pages/EventCenter'
import { _$, Table } from 'kpc-react'
import DetailDrawer from './DetailDrawer'
import CreateAlarmDrawer from './CreateAlarmDrawer'
import { Divider } from 'src/components'

const DialogBody: React.FC<any> = ({ className, tableData }) => {
  const { eventOptions, eventList } = useContext(CountContext)
  const [data, setData] = useState<any[]>([])
  const [detailVisible, setDetailVisible] = useState<boolean>(false)
  const [createAlarmVisible, setCreateAlarmVisible] = useState<boolean>(false)
  const [currentData, setCurrentData] = useState<any>()

  useEffect(() => {
    if (tableData.length && eventOptions.length) {
      const handleData = tableData.map(item => {
        const result = { ...item }
        // 查找productName
        const findProduct = eventOptions.find(({ value }) => parseInt(item.namespaceId) === value)
        result.productName = findProduct?.label || ''
        // 查找eventTypeName
        const findType = findProduct?.children.find(({ value }) => item.type === value)
        result.eventTypeName = findType?.label || ''
        // 查找eventName
        const findName = findType?.children.find(({ value }) => item.name === value)
        result.eventName = findName?.label || ''
        return result
      })
      setData(handleData)
    } else {
      setData([])
    }
  }, [tableData, eventOptions])

  // 新建告警
  const newAlarm = item => {
    const createDefaultValues = {
      ProductType: parseInt(item.namespaceId),
      EventRadio: 2,
      EventNames: [item.name]
    }
    setCurrentData(createDefaultValues)
    setCreateAlarmVisible(true)
  }

  // 详情
  const openDetail = item => {
    setCurrentData(item)
    setDetailVisible(true)
  }

  // table scheme
  const tableScheme = useMemo(() => {
    return {
      productName: {
        title: _$('产品类型'),
        width: 150
      },
      eventTypeName: _$('事件类型'),
      level: {
        title: _$('事件等级'),
        width: 150
      },
      eventName: _$('事件名称'),
      num: {
        title: _$('事件数量'),
        width: 100
      },
      active: {
        title: _$('操作'),
        width: 200,
        template: item => {
          return (
            <div className="ksc-space">
              <a className="primary-color" onClick={() => newAlarm(item)}>
                {_$('新建告警策略')}
              </a>
              <Divider />
              <a className="primary-color" onClick={() => openDetail(item)}>
                {_$('详情')}
              </a>
            </div>
          )
        }
      }
    }
  }, [])

  return (
    <div className={className}>
      <Table scheme={tableScheme} data={data} resizable={true} checkType="none" />
      <DetailDrawer visible={detailVisible} setVisible={setDetailVisible} data={currentData} />
      <CreateAlarmDrawer
        visible={createAlarmVisible}
        setVisible={setCreateAlarmVisible}
        eventList={eventList}
        defaultValues={currentData}
      />
    </div>
  )
}

export default styled(DialogBody)`
  .instance-table,
  .instance-filter {
    margin-top: 16px;
  }
`
